
import {Table} from 'react-bootstrap';

const ResultsTable = () => {
  return(
    <Table size="sm" responsive="md" className="results-table">
      <colgroup>
        <col id="col1"/>
        <col id="col2"/>
      </colgroup>
      <thead>
        <tr>
          <th>
            Method name
          </th>
          <th>
            Abbreviation
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            DiConfounder
          </td>
          <td>
            DiConf
          </td>
        </tr>
        <tr>
          <td>
            DiConfounder
          </td>
          <td>
            DiConf-v3*
          </td>
        </tr>
        <tr>
          <td>
            DiConfounder
          </td>
          <td>
            DiConf-v2*
          </td>
        </tr>
        <tr>
          <td>
            Double machine learning
          </td>
          <td>
            dml_1
          </td>
        </tr>
        <tr>
          <td>
            BART with cross validation and pscore as covariate
          </td>
          <td>
            xvalBARTps*
          </td>
        </tr>
        <tr>
          <td>
            BART with Ys on Pscore
          </td>
          <td>
            BTYPS
          </td>
        </tr>
        <tr>
          <td>
            BART with Ys on Pscore with Ys
          </td>
          <td>
            BTYPSY
          </td>
        </tr>
        <tr>
          <td>
            Double machine learning
          </td>
          <td>
            dml_2*
          </td>
        </tr>
        <tr>
          <td>
            Propensity score weighted weighted least squares
          </td>
          <td>
            ps_wls_1
          </td>
        </tr>
        <tr>
          <td>
            DiConfounder
          </td>
          <td>
            DiConf-v4*
          </td>
        </tr>
        <tr>
          <td>
            Propensity score weighted weighted least squares
          </td>
          <td>
            ps_wls_2*
          </td>
        </tr>
        <tr>
          <td>
            BART with cross validation
          </td>
          <td>
            xvalBART*
          </td>
        </tr>
        <tr>
          <td>
            stan4bart
          </td>
          <td>
            s4b*
          </td>
        </tr>
        <tr>
          <td>
            Simple GBM estimation of POs
          </td>
          <td>
            simpleGBM
          </td>
        </tr>
        <tr>
          <td>
            Simple GBM, revised intervals
          </td>
          <td>
            simpleGBM2*
          </td>
        </tr>
        <tr>
          <td>
            DiConfounder
          </td>
          <td>
            DiConfound
          </td>
        </tr>
        <tr>
          <td>
            BART on PSscore with Ys
          </td>
          <td>
            BTPSY
          </td>
        </tr>
        <tr>
          <td>
            Double/Debiased Machine Learning with Pseudo-Outcome Regression
          </td>
          <td>
            DML-POR
          </td>
        </tr>
        <tr>
          <td>
            Propensity score weighted double machine learning
          </td>
          <td>
            ps_dml_1
          </td>
        </tr>
        <tr>
          <td>
            DID model with IPTW
          </td>
          <td>
            ipwdid_1
          </td>
        </tr>
        <tr>
          <td>
            DID model with IPTW
          </td>
          <td>
            ipwdid_2*
          </td>
        </tr>
        <tr>
          <td>
            Propensity score weighted double machine learning
          </td>
          <td>
            ps_dml_2*
          </td>
        </tr>
        <tr>
          <td>
            A more flexible BART/BCF
          </td>
          <td>
            flexBART_1
          </td>
        </tr>
        <tr>
          <td>
            A more flexible BART/BCF
          </td>
          <td>
            flexBART_2
          </td>
        </tr>
        <tr>
          <td>
            DID model with IPTW
          </td>
          <td>
            ipwdidp*
          </td>
        </tr>
        <tr>
          <td>
            X-Learner with X and Ys without Ys in Pscore
          </td>
          <td>
            XLXYnoPsY
          </td>
        </tr>
        <tr>
          <td>
            X-Learner with X and Ys
          </td>
          <td>
            XLXY
          </td>
        </tr>	
        <tr>
          <td>
            Super-learning doubly-robust estimation with pretreatment data fusion
          </td>
          <td>
            SL-DR-F
          </td>
        </tr>  	
        <tr>
          <td>
            BART on PSscore
          </td>
          <td>
            BTPS
          </td>
        </tr>  	
        <tr>
          <td>
            BCF on PSscore
          </td>
          <td>
            BCFPS
          </td>
        </tr>
        <tr>
          <td>
            A more flexible BART/BCF
          </td>
          <td>
            flexBART_3
          </td>
        </tr>
        <tr>
          <td>
            DID model with IPTW
          </td>
          <td>
            ipwdidp2*
          </td>
        </tr>
        <tr>
          <td>
            Super-learning doubly-robust estimation
          </td>
          <td>
            SL-DR
          </td>
        </tr>
        <tr>
          <td>
            Super-learning doubly-robust estimation with pretreatment data fusion
          </td>
          <td>
            SL-DR-F2*
          </td>
        </tr>
        <tr>
          <td>
            Mildly Surprising Method +
          </td>
          <td>
            MSM+
          </td>
        </tr>  	
        <tr>
          <td>
            X-Learner with X
          </td>
          <td>
            XLX
          </td>
        </tr>
        <tr>
          <td>
            A more flexible BART/BCF
          </td>
          <td>
            flexBART_6*
          </td>
        </tr>
        <tr>
          <td>
            A more flexible BART/BCF
          </td>
          <td>
            flexBART_4*
          </td>
        </tr>
        <tr>
          <td>
            A more flexible BART/BCF
          </td>
          <td>
            flexBART_5*
          </td>
        </tr>
        <tr>
          <td>
            X-Learner with Ys
          </td>
          <td>
            XLY
          </td>
        </tr>  	
        <tr>
          <td>
            X-Learner with Ys without Ys in Pscore
          </td>
          <td>
            XLYnoPsY
          </td>
        </tr>   	
        <tr>
          <td>
            BART
          </td>
          <td>
            BT
          </td>
        </tr>
        <tr>
          <td>
            Double/Debiased Machine Learning with Pseudo-Outcome Regression
          </td>
          <td>
            DML-POR_2*
          </td>
        </tr>
        <tr>
          <td>
            Mildly Surprising Method
          </td>
          <td>
            MSM
          </td>
        </tr>	
        <tr>
          <td>
            Matching
          </td>
          <td>
            Matching
          </td>
        </tr>
        <tr>
          <td>
            TMLE
          </td>
          <td>
            TMLE*
          </td>
        </tr>
        <tr>
          <td>
            AIPW estimator + bootstrap CI
          </td>
          <td>
            aipwboot*
          </td>
        </tr>
        <tr>
          <td>
            Inverse Propensity Weighting
          </td>
          <td>
            IPW
          </td>
        </tr>
        <tr>
          <td>
            FisherBART
          </td>
          <td>
            FisherBART*
          </td>
        </tr>
        <tr>
          <td>
            XL-Learner
          </td>
          <td>
            XL-Learner_2*
          </td>
        </tr>
        <tr>
          <td>
            XL-Learner
          </td>
          <td>
            XL-Learner_1
          </td>
        </tr>  	
        <tr>
          <td>
            Doubly robust estimation for ATTE with subtracting time average effects, robust version
          </td>
          <td>
            DMLATT-T-R
          </td>
        </tr>
        <tr>
          <td>
            X-Learner
          </td>
          <td>
            XL
          </td>
        </tr>  	
        <tr>
          <td>
            X-Learner with X and practice-level Pscore and Ys
          </td>
          <td>
            XLXPsY
          </td>
        </tr>
        <tr>
          <td>
            X-Learner with X and practice-level Pscore
          </td>
          <td>
            XLXPs
          </td>
        </tr>
        <tr>
          <td>
            Doubly robust estimation for average difference between pre and post
          </td>
          <td>
            DML-AD*
          </td>
        </tr> 
        <tr>
          <td>
            Doubly robust estimation for ATTE with subtracting time average effects
          </td>
          <td>
            DMLATT-T
          </td>
        </tr>  	
        <tr>
          <td>
            Transformation, imputation, multilevel machine learning
          </td>
          <td>
            TransImpMLML
          </td>
        </tr>
      </tbody>
    </Table>
  )
}

export default ResultsTable;